/* CHICNET LUX ZOOM (safe, no dependencies) */
(function () {
  const SELECTORS = [
    '.product__media img',
    '.product-media img',
    '.product__gallery img',
    '.product-single__media img',
    '.media img',
    '.product__media-item img',
    '.product__media-wrapper img'
  ];

  function cssEscape(s) {
    try { return CSS.escape(s); } catch (e) { return s.replace(/[^a-zA-Z0-9_-]/g, '\\$&'); }
  }

  function getBestSrc(img) {
    return (
      img.currentSrc ||
      img.src ||
      (img.dataset && (img.dataset.src || img.dataset.zoom || img.dataset.original)) ||
      ''
    );
  }

  function createOverlay() {
    let overlay = document.getElementById('chicnetZoomOverlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'chicnetZoomOverlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML = `
      <div class="chicnet-zoom__backdrop"></div>
      <div class="chicnet-zoom__frame" tabindex="-1">
        <button class="chicnet-zoom__close" aria-label="Close">×</button>
        <img class="chicnet-zoom__img" alt="">
      </div>
    `;

    document.body.appendChild(overlay);

    const close = () => overlay.classList.remove('is-open');

    overlay.querySelector('.chicnet-zoom__backdrop').addEventListener('click', close);
    overlay.querySelector('.chicnet-zoom__close').addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    return overlay;
  }

  function openZoom(img) {
    const overlay = createOverlay();
    const overlayImg = overlay.querySelector('.chicnet-zoom__img');

    const src = getBestSrc(img);
    if (!src) return;

    overlayImg.src = src;

    // keep SEO-ish alt in zoom too
    overlayImg.alt = img.alt || document.title || 'Product image';

    overlay.classList.add('is-open');
    overlay.querySelector('.chicnet-zoom__frame').focus();
  }

  function bind() {
    const imgs = [];
    SELECTORS.forEach((sel) => document.querySelectorAll(sel).forEach((n) => imgs.push(n)));

    imgs.forEach((img) => {
      if (img.dataset.chicnetZoomBound === '1') return;
      img.dataset.chicnetZoomBound = '1';

      img.style.cursor = 'zoom-in';

      img.addEventListener('click', (e) => {
        // Don’t break sliders that use drag
        if (e.defaultPrevented) return;
        openZoom(img);
      });
    });
  }

  // initial + after theme sections reload
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
/* CHICNET LUX ZOOM (safe, no dependencies) */
(function () {
  const SELECTORS = [
    '.product__media img',
    '.product-media img',
    '.product__gallery img',
    '.product-single__media img',
    '.media img',
    '.product__media-item img',
    '.product__media-wrapper img'
  ];

  function cssEscape(s) {
    try { return CSS.escape(s); } catch (e) { return s.replace(/[^a-zA-Z0-9_-]/g, '\\$&'); }
  }

  function getBestSrc(img) {
    return (
      img.currentSrc ||
      img.src ||
      (img.dataset && (img.dataset.src || img.dataset.zoom || img.dataset.original)) ||
      ''
    );
  }

  function createOverlay() {
    let overlay = document.getElementById('chicnetZoomOverlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'chicnetZoomOverlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML = `
      <div class="chicnet-zoom__backdrop"></div>
      <div class="chicnet-zoom__frame" tabindex="-1">
        <button class="chicnet-zoom__close" aria-label="Close">×</button>
        <img class="chicnet-zoom__img" alt="">
      </div>
    `;

    document.body.appendChild(overlay);

    const close = () => overlay.classList.remove('is-open');

    overlay.querySelector('.chicnet-zoom__backdrop').addEventListener('click', close);
    overlay.querySelector('.chicnet-zoom__close').addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    return overlay;
  }

  function openZoom(img) {
    const overlay = createOverlay();
    const overlayImg = overlay.querySelector('.chicnet-zoom__img');

    const src = getBestSrc(img);
    if (!src) return;

    overlayImg.src = src;

    // keep SEO-ish alt in zoom too
    overlayImg.alt = img.alt || document.title || 'Product image';

    overlay.classList.add('is-open');
    overlay.querySelector('.chicnet-zoom__frame').focus();
  }

  function bind() {
    const imgs = [];
    SELECTORS.forEach((sel) => document.querySelectorAll(sel).forEach((n) => imgs.push(n)));

    imgs.forEach((img) => {
      if (img.dataset.chicnetZoomBound === '1') return;
      img.dataset.chicnetZoomBound = '1';

      img.style.cursor = 'zoom-in';

      img.addEventListener('click', (e) => {
        // Don’t break sliders that use drag
        if (e.defaultPrevented) return;
        openZoom(img);
      });
    });
  }

  // initial + after theme sections reload
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
